import {isTopLevelDataFrameView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {CustomDataViewButton} from 'analysis-tool/data-view/DataViewContext';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {AnalysisRightSidebarItem} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {AnalysisMainViewItem} from 'analysis-tool/ui/main-view/MainViewTypes';
import {createRenderAddChartViewButton} from 'data-frames/toolbar/toolbar-actions/renderAddChartViewButton';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';
import {getOutputDataForView} from 'pipelines/PipelineViewUtils';

export default function getAddViewAction(
  analysis: PipelineGraphQL,
  view: PipelineViewGraphQL,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void,
  onChangeSelectedRightSidebarItem: (newSelectedRightSidebarItem: AnalysisRightSidebarItem | null) => void
): CustomDataViewButton {
  const outputData = getOutputDataForView(view);
  if (isAnalysisReadOnly(analysis) || !isTopLevelDataFrameView(view, analysis)) {
    return null;
  }

  const lastStep = view.lineage[view.lineage.length - 1].step;
  // @ts-expect-error: The return type of createRenderAddChartViewButton expects arguments, but the actual
  // function it returns doesn't need them
  return createRenderAddChartViewButton(
    analysis,
    lastStep.id,
    outputData!.id,
    onChangeSelectedItem,
    onChangeSelectedRightSidebarItem
  )();
}
